import React from 'react';
type Props = {
  fillColor?: string;
} & typeof defaultProps;

const defaultProps = {
  fillColor: '#000',
};
const ResearchInvertedIcon = function ResearchInvertedIcon(props: Props) {
  const { fillColor } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
      <path
        d="M17.7254 8.9933H19.4314C19.8736 8.9933 20.1474 8.50126 19.9158 8.11618L16.7987 3.04595C16.567 2.68226 16.0616 2.68226 15.8299 3.04595L12.7129 8.11618C12.4812 8.50126 12.755 8.9933 13.1973 8.9933H14.9032C14.9032 9.12166 14.9032 9.27142 14.8822 9.42117C14.6926 12.459 12.2495 14.9193 9.25887 15.1118C5.53106 15.3471 2.47721 12.1381 2.85631 8.3515C3.15116 5.52758 5.34151 3.25988 8.10051 2.91758C9.25887 2.76783 10.3751 2.96037 11.3439 3.40963C11.6598 3.55939 12.0389 3.43103 12.2074 3.13152L12.9656 1.84792C13.1762 1.50562 13.0288 1.03497 12.6708 0.863821C11.4282 0.264806 10.0381 -0.0560946 8.56385 0.00808552C3.9936 0.157839 0.244737 3.88029 0.0130658 8.50126C-0.260728 13.6785 3.80405 17.9999 8.85871 17.9999C13.7449 18.0213 17.7254 13.978 17.7254 8.9933Z"
        fill={fillColor}
      />
    </svg>
  );
};
ResearchInvertedIcon.defaultProps = defaultProps;
export default ResearchInvertedIcon;
